module.exports = __webpack_public_path__ + "img/sala_do_empreendedor_bronze.59a0e649.png";